import { render, staticRenderFns } from "./StrProsesGiris.vue?vue&type=template&id=7bfe7d43"
import script from "./StrProsesGiris.vue?vue&type=script&lang=js"
export * from "./StrProsesGiris.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports